module.exports = __webpack_public_path__ + "img/unverified.c21b0611.svg";